import Companies from "./Companies/Index";
import Vehicles from "./Vehicles/Index";

export default class SEGES{
    static Vehicles = Vehicles;
    static Companies = Companies;
}